

(function () {
  'use strict';
  angular.module('vcutils.config')
    .component('version', {
      restrict: 'E',
      bindings: {},
      template: `
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3>Version</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <h4 ng-bind="vm.version"></h4>
          </div>  
        </div>
  `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', '$http',
        function ($log, Rlog, $http) {
          let vm = this;

          vm.$onInit = function () {
            $http.get('/routes/version')
              .then(function success(v) {
                  vm.version = v.data;
                },
                function failure(e) {
                  vm.error = e.statusText + ' (Error: ' + e.status + ')';
                });
          };
        }] // controller
    }); // component

  // klammerfriedhof
}());